export const socialMediaList = {
  discord: "https://discord.gg/7NFVRymVZf",
  twitter: "https://twitter.com/_WEB3M_",
  linkedin: "https://il.linkedin.com/company/web3-m",
  tiktok: "https://www.tiktok.com/@web3m",
};
